module.exports = __webpack_public_path__ + "static/media/aceN_Logo.1637acd0.png";